export const sanitizePasswordInput = (
  input: string,
  setError: React.Dispatch<React.SetStateAction<string | null>>
) => {
  // ハッシュ化できない文字検査
  const invalidChars = /[\x00-\x1F\x7F]/g;
  if (invalidChars.test(input)) {
    setError("エラー: 無効な文字（制御文字）が含まれています。");
    return "";
  }

  // データベースに保存できない文字チェック
  const unsafeChars = /['";\\]/g;
  if (unsafeChars.test(input)) {
    setError(
      "エラー: 不正な文字（SQLインジェクションの可能性がある文字）が含まれています。"
    );
    return "";
  }

  // 環境依存文字検査
  const bomChars = /^\ufeff/g;
  if (bomChars.test(input)) {
    setError("エラー: BOM（バイトオーダーマーク）文字が含まれています。");
    return "";
  }

  // エラーない場合、成功
  setError("");
  return input;
};